var React = require('react');

function IconMicrophone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 0c-3.313 0-6 2.688-6 6v10c0 3.313 2.688 6 6 6 3.313 0 6-2.688 6-6V6c0-3.313-2.688-6-6-6ZM8 13.5c0-.831-.669-1.5-1.5-1.5S5 12.669 5 13.5V16c0 5.569 4.137 10.169 9.5 10.9V29h-3c-.831 0-1.5.669-1.5 1.5s.669 1.5 1.5 1.5h9c.831 0 1.5-.669 1.5-1.5s-.669-1.5-1.5-1.5h-3v-2.1c5.363-.731 9.5-5.331 9.5-10.9v-2.5c0-.831-.669-1.5-1.5-1.5s-1.5.669-1.5 1.5V16a8 8 0 0 1-8 8 8 8 0 0 1-8-8v-2.5Z","fill":"currentColor"}));
}

IconMicrophone.defaultProps = {"fill":"none","viewBox":"0 0 32 32"};

module.exports = IconMicrophone;

IconMicrophone.default = IconMicrophone;
